/** @format */

import React from 'react';

export default function About() {
  return (
    <section id="about">
      <div className="container flex flex-col items-center px-10 py-10 mx-auto md:flex-row">
        <div className="flex flex-col items-center mb-16 text-center lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 md:items-start md:text-left md:mb-0">
          <h1 className="mb-4 text-3xl font-medium text-white title-font sm:text-4xl">
            Hi, I'm Mohamed.
            <br className="hidden lg:inline-block" /> A fullstack software engineer
          </h1>
          <p className="mb-8 leading-relaxed">
            Here, you can know more about me through my resume, past works and
            interests. I am passionate about quality coding and system design, always striving to improve my skills.
            I am constantly looking for new opportunities to grow and excel in my field.
          </p>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex px-6 py-2 mt-4 text-base text-white bg-green-500 border-0 rounded focus:outline-none hover:bg-gray-700 md:mt-0"
            >
              Work With Me
            </a>
            <a
              href="#projects"
              className="inline-flex px-6 py-2 ml-4 text-lg text-gray-400 bg-gray-800 border-0 rounded focus:outline-none hover:bg-gray-700 hover:text-white"
            >
              See My Past Work
            </a>
          </div>
        </div>
        <div className="w-5/6 lg:max-w-lg lg:w-full md:w-1/2 ">
          <img
            className="object-cover object-center rounded"
            alt="hero"
            src="./coding.svg"
          />
          {/* <div className="container flex flex-col flex-wrap items-center p-5 mx-auto justify-items-end md:flex-row">
            <a
              className="inline-flex items-center px-6 py-2 ml-8 text-base text-white bg-green-500 rounded border-10 focus:outline-none hover:bg-gray-700"
              href={resume}
              attributes-list
              download="Resume"
            >
              {' '}
              My Resume
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
}
